import { render, staticRenderFns } from "./Form_submit.vue?vue&type=template&id=c228f700&scoped=true"
import script from "./Form_submit.vue?vue&type=script&lang=js"
export * from "./Form_submit.vue?vue&type=script&lang=js"
import style0 from "./Form_submit.vue?vue&type=style&index=0&id=c228f700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c228f700",
  null
  
)

export default component.exports